<template>
  <div>
    <img src="../../../assets/images/qr-code.png" width="50%" style="display: none;" />

    <div id="box" style="display: none;">
    </div>
    <!-- <div class="box"></div> -->
    <!-- 定部 -->
    <div class="header">
      <div class="header-l" @click="navto(1)">
        <img src="../../../assets/images/手机端/首页手机端/logo拷贝.png" alt="">
      </div>
      <button class="addbtn" @click="dialogShow = true" style="margin-left: 2.3rem; width: 4rem;">立即咨询</button>
      <div id="btn" class="header-r" @click="addnav">
        <img src="../../../assets/images/手机端/首页手机端/更多.png" alt="">
      </div>
    </div>
    <div class="top-img">
      <h3>域贝可视化平台（一云看板）</h3>
      <div class="button">
        <!-- <button class="addbtn" @click="onClickTo">立即体验</button> -->
        <button class="addbtn" @click="dialogShow = true" style="width: 3rem;">立即咨询</button>
        <button class="addbtn" @click="onEnter()" style="width: 3rem;">立即体验</button>

      </div>
        <div class="xiaokanban">
          <img src="../../../assets/images/动态模版1.png" :class="{ active: visualIndex == 0 }" style="opacity: 0;" alt="" />
          <img src="../../../assets/images/动态模版2.png" :class="{ active: visualIndex == 1 }" style="opacity: 0;" alt="" />
          <img src="../../../assets/images/动态模版3.png" :class="{ active: visualIndex == 2 }" style="opacity: 0;" alt="" />
        </div>
        <div class="mobilekanban">
          <img src="../../../assets/images/手机长图1.png" :class="{ active: visualIndex == 0 }" style="opacity: 0;" alt="" />
          <img src="../../../assets/images/手机长图2.png" :class="{ active: visualIndex == 1 }" style="opacity: 0;" alt="" />
          <img src="../../../assets/images/手机长图3.png" :class="{ active: visualIndex == 2 }" style="opacity: 0;" alt="" />
        </div>
        <div class="bigkanban">
          <img src="../../../assets/images/数据大屏1.png" :class="{ active: visualIndex == 0 }" style="opacity: 0;" alt="" />
          <img src="../../../assets/images/数据大屏2.png" :class="{ active: visualIndex == 1 }" style="opacity: 0;" alt="" />
          <img src="../../../assets/images/数据大屏3.png" :class="{ active: visualIndex == 2 }" style="opacity: 0;" alt="" />
        </div> 
    </div>
    <div class="main-1">
      <h3>产品优势</h3>
      <ul>
        <li>
          <img src="../../../assets/images/andvantage-one.png" alt="">
          <p>精美模版，适用多行业</p>
        </li>
        <li>
          <img src="../../../assets/images/andvantage-two.png" alt="">
          <p>简单易学，可轻松上手</p>
        </li>
        <li>
          <img src="../../../assets/images/andvantage-three.png" alt="">
          <p>实时接入，主流数据库</p>
        </li>
        <li>
          <img src="../../../assets/images/andvantage-four.png" alt="">
          <p>兼容并包，开放第三方</p>
        </li>
      </ul>
    </div>
    <div class="gojia">
      <h3>为什么选择域贝可视化</h3>
      <p>零代码数据可视化平台</p>

      <div class="title">
        <div class="name" v-if="gifIndex == 1">精美模版 超多素材
        </div>
        <div v-if="gifIndex == 1" class="number">01</div>

        <div class="name" v-if="gifIndex == 2">简易编辑 一步到位
        </div>
        <div v-if="gifIndex == 2" class="number">02</div>

        <div class="name" v-if="gifIndex == 3">看板互联 快速切换
        </div>
        <div v-if="gifIndex == 3" class="number">03</div>

        <div class="name" v-if="gifIndex == 4">自定义 多功能分享
        </div>
        <div v-if="gifIndex == 4" class="number">04</div>

      </div>

      <div class="bottom">
        {{ gifWord[gifIndex] }}
      </div>

      <swiper class="slide" :options="swiperOption2">
        <swiper-slide >
          <img src="../../../assets/images/手机端/可视化/海量模版.gif" v-if="gifIndex == 1" alt="" class="wow slideInRight gif"
            data-wow-delay="0.20s" data-wow-offset="20" />
        </swiper-slide>
        <swiper-slide >
          <img src="../../../assets/images/手机端/可视化/简易编辑.gif" v-if="gifIndex == 2" alt="" class="wow slideInRight gif"
            data-wow-delay="0.20s" data-wow-offset="20" />
        </swiper-slide>
        <swiper-slide >
          <img src="../../../assets/images/手机端/可视化/看板互联.gif" v-if="gifIndex == 3" alt="" class="wow slideInRight gif"
            data-wow-delay="0.20s" data-wow-offset="20" />
        </swiper-slide>
        <swiper-slide >
          <img src="../../../assets/images/手机端/可视化/自定义分享.gif" v-if="gifIndex == 4" alt="" class="wow slideInRight gif"
            data-wow-delay="0.20s" data-wow-offset="20" />
        </swiper-slide>
      </swiper>

      <div style="height: 0.1rem; display: flex; justify-content: center; margin-top: 0.3rem;">
        <div :class="gifIndex == 1 ? 'pagi_back_color' : ''" style="height: 0.1rem; width: 1rem; background-color: rgba(173, 178, 179, 1); margin-right: 0.12rem;"></div>
        <div :class="gifIndex == 2 ? 'pagi_back_color' : ''" style="height: 0.1rem; width: 1rem; background-color: rgba(173, 178, 179, 1); margin-right: 0.12rem;"></div>
        <div :class="gifIndex == 3 ? 'pagi_back_color' : ''" style="height: 0.1rem; width: 1rem; background-color: rgba(173, 178, 179, 1); margin-right: 0.12rem;"></div>
        <div :class="gifIndex == 4 ? 'pagi_back_color' : ''" style="height: 0.1rem; width: 1rem; background-color: rgba(173, 178, 179, 1); margin-right: 0.12rem;"></div>
      </div>      

      <!-- <img src="../../../assets/images/手机端/可视化/海量模版.gif" v-if="gifIndex == 1" alt="" class="wow slideInRight gif"
        data-wow-delay="0.20s" data-wow-offset="20" />
      <img src="../../../assets/images/手机端/可视化/简易编辑.gif" v-if="gifIndex == 2" alt="" class="wow slideInRight gif"
        data-wow-delay="0.20s" data-wow-offset="20" />
      <img src="../../../assets/images/手机端/可视化/看板互联.gif" v-if="gifIndex == 3" alt="" class="wow slideInRight gif"
        data-wow-delay="0.20s" data-wow-offset="20" />
      <img src="../../../assets/images/手机端/可视化/自定义分享.gif" v-if="gifIndex == 4" alt="" class="wow slideInRight gif"
        data-wow-delay="0.20s" data-wow-offset="20" />
       -->
    </div>

    <div class="main-2">
      <h3>域贝可视化可应用于众多场景</h3>

      <div class="sub_title">一起探索更多应用场景，无限延伸可视化未来</div>

      <!-- <div class="tab">
        <div class="tab-item" :class="{ active: activeIndex === 1 }" @click="onClickActive(1)">城市</div>
        <div class="tab-item" :class="{ active: activeIndex === 2 }" @click="onClickActive(2)">工厂</div>
        <div class="tab-item" :class="{ active: activeIndex === 3 }" @click="onClickActive(3)">园区</div>
        <div class="tab-item" :class="{ active: activeIndex === 4 }" @click="onClickActive(4)">校园</div>
        <div class="tab-item" :class="{ active: activeIndex === 5 }" @click="onClickActive(5)">设备</div>
        <div class="tab-item" :class="{ active: activeIndex === 6 }" @click="onClickActive(6)">医疗</div>
        <div class="tab-item" :class="{ active: activeIndex === 7 }" @click="onClickActive(7)">物流</div>
        <div class="tab-item" :class="{ active: activeIndex === 8 }" @click="onClickActive(8)">交通</div>
      </div> -->

      <swiper class="slide1" :options="swiperOption1">
        <swiper-slide >
          <div class="tab-item" :class="{ active: activeIndex === 1 }" @click="onClickActive(1)" >城市</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 2 }" @click="onClickActive(2)">工厂</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 3 }" @click="onClickActive(3)">园区</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 4 }" @click="onClickActive(4)">校园</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 5 }" @click="onClickActive(5)">设备</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 6 }" @click="onClickActive(6)">医疗</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 7 }" @click="onClickActive(7)">物流</div>
        </swiper-slide>
        <swiper-slide>
          <div class="tab-item" :class="{ active: activeIndex === 8}" @click="onClickActive(8)">交通</div>
        </swiper-slide>
      </swiper>

      <swiper class="swiper-container" ref="mySwiper" :options="swiperOption">
        <swiper-slide>
          <img src="../../../assets/MP4/城市.gif" alt="" v-if="activeIndex == 1" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 1">
            <source src="../../../assets/MP4/城市.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/工程.gif" alt="" v-if="activeIndex == 2" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 2">
            <source src="../../../assets/MP4/工程.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/园区.gif" alt="" v-if="activeIndex == 3" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 3">
            <source src="../../../assets/MP4/园区.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/校园.gif" alt="" v-if="activeIndex == 4" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 4">
            <source src="../../../assets/MP4/校园.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/设备.gif" alt="" v-if="activeIndex == 5" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 5">
            <source src="../../../assets/MP4/设备.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/医疗.gif" alt="" v-if="activeIndex == 6" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 6">
            <source src="../../../assets/MP4/医疗.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/物流.gif" alt="" v-if="activeIndex == 7" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 7">
            <source src="../../../assets/MP4/物流.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <swiper-slide>
          <img src="../../../assets/MP4/交通.gif" alt="" v-if="activeIndex == 8" style="height: 100%;" />
          <!-- <video width="100%" height="100%" muted controls v-if="activeIndex == 8">
            <source src="../../../assets/MP4/交通.mp4" type="video/mp4">
          </video> -->
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>

    </div>

    <div class="main-3">
      <h3>个性化定制模版</h3>
      <div class="sub_title">量身定制专属模版</div>
      <p>
        数据可视化大屏作为数据价值最直观的体现，广泛应用于日常办公、应急处理、指挥调度、科学决策等场景。
      </p>
      <button class="addbtn btn" @click="dialogShow = true">了解详情</button>

    </div>


    <div class="contact">
      <div class="container_data">
        <div class="contact-box">
          <div class="left">
            <h3>免费试用域贝可视化</h3>
            <button class="addbtn" @click="dialogShow = true">立即咨询</button>

          </div>
          <div class="right">
            <div class="contact-img">
              <img src="../../../assets/images/contact1.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="footer">
      <ul>
        <li @click="goyuzan">
          <p>玉瓒云校园</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu = !subMenu">
          <p>一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'visualizationpage' })">
          <p>产品详情</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'pricepage' })">
          <p>产品定价</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu2 = !subMenu2">
          <p>域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="goproductservice">
          <p>域贝证书宝</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="gointegratedpage">
          <p>域贝一体化</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="godate">
          <p>域贝大数据</p>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <div class="logn">
        <img src="../../../assets/images/img/首页 手机端/logo.png" alt="">
      </div>
      <div class="dianhua">
        <p><img src="../../../assets/images/img/首页 手机端/电话(1).png" alt="">400-051-0806</p>
      </div>
      <div class="dizhi">
        <p><img src="../../../assets/images/img/首页 手机端/地址.png" alt="">浙江省温州市鹿城区车站大道11号高联大厦1608室</p>
      </div>
      <img @click="iswei" class="erweima" src="../../../assets/images/img/首页手机端/二维码.png" alt="">

      <div class="footer-bottom">
        <p>备案号：浙ICP备13031672-1</p>
      </div>
    </div>
    <div class="mask"></div>
    <div class="mask"></div>
    <div class="mask1"></div>
    <div class="erweima1">
    </div>
    <div class="ismask" @click.self="qiemask" v-show="ismask">
      <div class="isnav" v-show="isnav">

        <ul>
          <li @click="navto(1)">首页</li>
          <li @click="navto(9)">玉瓒云校园</li>
          <li @click="subMenu = !subMenu">一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu" class="subLi" @click="navto(7)">产品详情</li>
          <li v-if="subMenu" class="subLi" @click="navto(8)">产品定价</li>
          <li @click="subMenu2 = !subMenu2">域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu2" class="subLi" @click="navto(2)">域贝证书宝</li>
          <li v-if="subMenu2" class="subLi" @click="navto(3)">域贝大数据</li>
          <li v-if="subMenu2" class="subLi" @click="navto(4)">域贝一体化</li>
          <!-- <li @click="navto(2)">域贝证书宝</li>
          <li @click="navto(3)">域贝大数据</li>
          <li @click="navto(4)">域贝一体化</li> -->
          <li @click="navto(5)">解决方案</li>
          <li @click="navto(6)">关于掌网</li>
        </ul>
      </div>
    </div>
    <div v-show="isweixiang" class="iserweima" @click.stop.self.prevent="isis">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>

    <van-dialog v-model="dialogShow" title="请联系您的专属客服咨询">
      <div style="display: flex; justify-content: center;">
        <img src="../../../assets/images/qr-code.png" width="50%" />
      </div>
    </van-dialog>
    <van-dialog v-model="LinkDialogShow" width="12rem" title="登陆成功" confirmButtonText="退出">
      <div style="display:flex;justify-content: center;flex-direction:column;align-items:center;">
        <div style="margin:0 0.4rem;margin-top:0.5rem;">
          <div class="tip2" style="font-size: 0.60rem;color: #8A94A9;text-align: center;margin-bottom:0.2rem;">复制下方链接<br>请使用电脑开启可视化之旅</div>
          <el-input placeholder="请输入内容"  class="input-with-select" v-model="text" id="copyContent" readonly=true>
            <el-button slot="append" @click="onCopy()">复制链接</el-button>
          </el-input>
        </div>
        <img src="../../../assets/images/qr-code.png" width="50%" style="margin-bottom:-0.3rem;"/>
        <div class="tip1" >联系客服获取您的专属福利</div>

        
      </div>
    </van-dialog>
    <Login :loginVisible="showLogin" @close="showLogin = false" @showLink="LinkDialogShow = true"></Login>

    <div v-show="callUsDialog" :class="[callUsIndex === 0 ? 'callUs' : 'callUs_2']"
      @click.stop.self.prevent="closeCallUs">
      <div :class="[callUsIndex === 0 ? 'callUs_dialog' : 'callUs_dialog_2']">
        <div class="callUs_title">
          <img class="down" @click="closeCallUs" src="../../../assets/images/手机端/首页手机端/向右箭头备份5.png" alt="">
          <p>联系我们</p>
        </div>
        <div class="bottom_msg">
          <p>您的称呼</p>
          <input :value="name" placeholder="请输入您的称呼" />
          <p>手机号码</p>
          <input :value="phone" placeholder="请输入您的手机号码" />
          <button class="callUs_btn" @click="closeCallUs">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Login from '@/views/Login/mobileLogin.vue'
import 'swiper/css/swiper.css'
export default {

  components: {
    swiper,
    swiperSlide,
    Login
  },

  data() {
    const _self = this
    return {
      text:'http://yb.yuzanyun.com/#/',
      LinkDialogShow:false,
      dialogShow: false,
      showLogin: false,
      isnav: false,
      ismask: false,
      isweixiang: false,
      callUsDialog: false,
      callUsIndex: 0,
      name: '',
      phone: '',
      activeIndex: 1,
      swiperOption1: {
        slidesPerView: 6,
      },
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        on: {
          slideChangeTransitionEnd: function () {
            _self.activeIndex = this.activeIndex + 1
          }
        }
      },
      swiperOption2: {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        on: {
          slideChangeTransitionEnd: function () {
            _self.gifIndex = this.activeIndex + 1
          }
        }
      },
      gifIndex: 1,
      gifGif: [
        '',
        '../../../assets/images/手机端/可视化/海量模版.gif',
        '../../../assets/images/手机端/可视化/简易编辑.gif',
        '../../../assets/images/手机端/可视化/看板互联.gif',
        '../../../assets/images/手机端/可视化/自定义分享.gif',
      ],
      gifWord: [
        '',
        '数十款精美模板任你选择,超多场景适用，零代码实现专属于你的看板',
        '后台填充数据，无更多繁琐操作，数据看板自动变化',
        '实时动态更新，海量数据汇总，一键切换看板，多屏分享同时展示，无需等待',
        '“傻瓜式”快速生成一键分享，将精心制作的看板与同事、领导共享，简单又快捷！'
      ],
      subMenu: false,
      subMenu2: false,
      visualIndex: 0,
    }
  },
  mounted() {
    // console.log(this.$refs.callUs_dialog.style.animation = 'callUs 1s infinite;'
    let i =0;
    this.time1 = setInterval(() => {
          i=i+1
          this.visualIndex=i%3
        }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.time1);
  },
  methods: {
    onCopy() {
      const copyContent = document.querySelector('#copyContent');
      copyContent.select();
      document.execCommand('copy');
      console.log(navigator.clipboard)
      this.$toast.success('复制成功');
    },
    onEnter() {
      let token = localStorage.getItem("token");
      if (token) {
        this.LinkDialogShow = true
      } else {
        this.showLogin = true
      }
    },
    onClickActive(index) {
      // 获取swiper实例

      this.activeIndex = index
      this.$refs.mySwiper.swiper.slideTo(index - 1)
    },

    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
      // seek to 10s
      console.log('example player 1 readied', player)
      player.currentTime(10)
      // console.log('example 01: the player is readied', player)
    },

    iswei() {
      this.isweixiang = true
    },
    isis() {
      this.isweixiang = false
    },
    onClickTo() {
      window.location.href = 'http://yb.yuzanyun.com/#/'
    },
    openCallUs() {
      this.callUsIndex = 0
      this.callUsDialog = true
      this.$refs.callUs_dialog.animation = 'callUs 1s infinite;'
    },
    closeCallUs() {
      this.callUsIndex = 1
      setTimeout(() => {
        this.callUsDialog = false
      }, 500);
    },
    goVisual() {
      // 回到页面最上面
      document.documentElement.scrollTop = 0
    },
    goPrice() {
      this.$router.push({ path: 'pricepage' })
    },
    goproductservice() {
      this.$router.push({ path: 'hoproductservicepage' })
    },
    godate() {
      this.$router.push({ path: 'hodate' })
    },
    goyuzan() {
      window.location.href='http://www.yuzanyun.com'
    },
    gointegratedpage() {
      this.$router.push({ path: 'integratedpage' })
    },
    addnav() {
      this.ismask = !this.ismask
      this.isnav = !this.isnav
    },
    qiemask() {
      console.log(111);
      this.ismask = false
      this.isnav = false
    },
    navto(n) {
      if (n == 1) {
        this.$router.push({ path: 'index' })
      } else if (n == 2) {
        this.$router.push({ path: 'hoproductservicepage' })
      } else if (n == 3) {
        this.$router.push({ path: 'hodate' })

      } else if (n == 4) {
        this.$router.push({ path: 'integratedpage' })
      } else if (n == 5) {
        this.$router.push({ path: 'cooperationpage' })
      } else if (n == 6) {
        this.$router.push({ path: 'aboutpage' })
      } else if (n == 7) {
        this.ismask = false
        this.isnav = false
      } else if (n == 8) {
        this.$router.push({ path: 'pricepage' })
      } else if (n == 9) {
        window.location.href='http://www.yuzanyun.com'
      }
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}

/deep/ .van-button__text {
  color: rgba(86, 126, 255, 1);
}

/* html {
  font-size: 50px;
} */

/* @media screen and (min-width: 1171px) {
  html {
    font-size: 78.666666667px;
  }
} */
@media screen and (min-width: 320px) {
  html {
    font-size: 21.33333333px;
  }
}

@media screen and (min-width: 360px) {
  html {
    font-size: 24px;
  }
}

@media screen and (min-width: 375px) {
  html {
    font-size: 25px;
  }
}

@media screen and (min-width: 384px) {
  html {
    font-size: 25.6px;
  }
}

@media screen and (min-width: 390px) {
  html {
    font-size: 26px;
  }
}

@media screen and (min-width: 400px) {
  html {
    font-size: 26.66666667px;
  }
}

@media screen and (min-width: 414px) {
  html {
    font-size: 27.6px;
  }
}

@media screen and (min-width: 424px) {
  html {
    font-size: 28.26666667px;
  }
}

@media screen and (min-width: 480px) {
  html {
    font-size: 32px;
  }
}

@media screen and (min-width: 540px) {
  html {
    font-size: 36px;
  }
}

@media screen and (min-width: 720px) {
  html {
    font-size: 48px;
  }
}

@media screen and (min-width: 750px) {
  html {
    font-size: 50px;
  }
}

li {
  list-style: none;
}

p {
  margin: 0;
}

ul {
  margin: 0;
  padding: 0;
}

body {
  min-width: 320px;
  max-width: 750px;
  width: 15rem;
  margin: 0 auto;
  line-height: 1.5;
  font-family: PingFangSC-Regular, sans-serif;
  background: #F2F2F2;
}
.tip1{
  font-size: 0.5rem;
  color: #8A94A9;
  text-align: center;
  height:1rem;
  line-height:1.25rem;
  z-index:3;
  background: url("../../../assets/images/手机端/矩形 2@3x.png");
  background-size: 100% 100%;
  color: #FFFFFF!important;
  padding: 0 3%;
  margin: 0 2%;
  margin-bottom: 0.3rem;
}
/deep/.input-with-select .el-input__inner:focus {
  // background-color: #000!important;
  border: 1px #C0C4CC solid !important;
  outline: none!important;
}
/deep/ .van-dialog .van-dialog__header {
  font-size: 1.2rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  height: 2.4rem;
  padding-bottom: .4688rem;
  width: 100%;
  padding-top: .7031rem;
  background-color: #fff;
  z-index: 1999;
}

.header-l {
  float: left;
  margin-left: .75rem;
  /* background-image: url('../images/首页 手机端/logo.png'); */
}

.header-l img {
  height: .8rem;
  object-fit: cover;
}

.header-r {
  width: 1.75rem;
  height: 1.375rem;
  float: right;
}

.header-r img {
  width: .62rem;
  height: .5rem;
}

.top-img {
  margin-top: 2.4rem;
  padding-top: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: .4rem;
  width: 100%;
  height: calc(910rem/50);
  // height:  18.85rem;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/手机端/可视化/首图背景.png');
  position: relative;

  .change-img {
    position: absolute;
    left: 2.6rem;
    bottom: 0.5rem;
    width: 7.4rem !important;
    height: fit-content !important;
  }
}

.top-img h3 {
  font-weight: 600;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: .72rem;
  margin-left: .5rem;
  margin: 0;
  // margin-top: 2rem;
  color: #000;
  letter-spacing: 0.1rem;
}

.top-img p {
  // text-indent: 2em;
  margin-top: .64rem;
  margin-left: 0;
  font-size: .62rem;
  line-height: .85rem;
  color: #000;
  text-align: justify;
  letter-spacing: 0.05rem;
}

.top-img .button {
  // text-align: center;
  // height: 0;

  .second {
    border: 1px solid #567EFF !important;
    background: transparent !important;
    color: #567EFF !important;
  }
}

.top-img .button button {
  width: 3.9rem;
  height: 1.34rem;
  margin-top: .8rem;
  // border: 1px solid #999 !important;
  /* background-color: rgba(255, 255, 255, 0.1); */
  // background: transparent;
  border: 0px;
  color: #4d5b75;
  font-size: .52rem;
  margin-bottom: .92rem;

  &:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
  }
}

            .xiaokanban {
              position: absolute;
              top: calc(439rem/50);
              left: calc(107rem/50);
              width: calc(119rem/50);
              height: calc(216rem/50);
              background: url(../../../assets/images/动态模版背景.png) center/cover;
              img {
                position: absolute;
                width: calc(119rem/50);
                height: calc(216rem/50);
              }
              img.active{
                position: absolute;
                opacity: 1!important;
                transition: opacity .4s!important;
      }
            }
            .mobilekanban {
              position: absolute;
              top: calc(474rem/50);
              left: calc(230rem/50);
              width: calc(131rem/50);
              height: calc(386rem/50);
              z-index: 1;
              background: url(../../../assets/images/手机长图背景.png) center/cover;
              img {
                position: absolute;
                width: calc(131rem/50);
                height: calc(386rem/50);
              }
              img.active{
                position: absolute;
                opacity: 1!important;
                transition: opacity .8s!important;
            }
            }
            .bigkanban {
              position: absolute;
              top: calc(347rem/50);
              left: calc(197rem/50);
              width: calc(552.5rem/50);
              height: calc(466.8rem/50);
              background: url(../../../assets/images/数据大屏背景.png) center/cover;
              img {
                position: absolute;
                width: calc(552.5rem/50);
              height: calc(466.8rem/50);
              }
              img.active{
                position: absolute;
                opacity: 1!important;
                transition: opacity .4s!important;
            }
            }
.main-4 {
  margin-bottom: 1.6rem;
  padding: 0 .3125rem;
}

.main-4 h3 {
  margin-top: 0;
  padding-top: 1.6rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem;
}

.main-4 p {
  text-align: center;
  font-size: .52rem;
  color: #8D93AB;
}

.main-4 ul {
  display: flex;
  flex-wrap: wrap;
}

.main-4 ul li img {
  width: 2.3rem;
}

.main-4 ul li {
  text-align: center;
  width: 50%;
  margin-top: 1rem;
  /* margin-bottom: .8rem; */

  .icon {
    width: 80px;
    height: 45px;
    position: relative;
    margin: 0 auto 30px;

    img:first-child {
      // position: absolute;
      z-index: 1;
      width: 50px;
      // height: 78px;
      // left: 0;
      // top: 0;
      transition: all 0.3s;
    }

    // img:last-child {
    //   position: absolute;
    //   z-index: 2;
    //   width: 80px;
    //   // bottom: -5px;
    //   // right: -8px;
    //   transition: all 0.3s;
    // }
  }
}


.main-4 ul li p {
  color: #444444;
  font-size: .62rem;
}

.main-4 ul li div {
  margin-top: .3rem;
  color: #8D93AB;
  font-size: 0.42rem;
}

.main-1 {
  margin-bottom: 1.6rem;
  padding: 0 .3125rem;

}

.main-1 h3 {
  margin-top: 0;
  padding-top: 1.6rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem;
}

.main-1 ul {
  display: flex;
  flex-wrap: wrap;
}

.main-1 ul li img {
  width: 2.3rem;
}

.main-1 ul li {
  text-align: center;
  width: 50%;
  /* margin-bottom: .8rem; */
}

.main-1 ul li:nth-child(1),
.main-1 ul li:nth-child(1) {
  margin-bottom: 2rem;
}

.main-1 ul li p {
  color: #2c3e5c;
  margin-top: 26px;
  font-size: .52rem;
}

.gojia {
  /* margin-bottom: 1.5625rem; */
  // text-align: center;
  width: 100%;
  height: 18.6rem;
  background-size: 100% 100%;
  // background-image: url('../../../assets/images/手机端/可视化/为什么选择背景@3x.png');
  background: linear-gradient(180deg, #FFFFFF 0%, #F5FEFF 100%);
  padding-top: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;

  h3 {
    font-weight: 600;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: .72rem;
    margin-left: .5rem;
    margin: 0;
    // margin-top: 2rem;
    color: #000;
    text-align: center;
  }

  p {
    // text-indent: 2em;
    margin-top: .44rem;
    margin-left: 0;
    font-size: .52rem;
    line-height: .85rem;
    color: #999;
    text-align: center;
  }

  .title {
    color: #567EFF;
    font-size: calc(36rem/50);
    margin-top: 1.3rem;
    position: relative;

    .name {
      position: relative;
      line-height: 1.3rem;
      height: 1.6rem;
      z-index: 10 !important;
    }
    .number {
        position: absolute;
        color: #DFE4EA;
        font-size: 1rem;
        line-height: 0;
        left: 0;
        top: 0;
        z-index: 1;
      }
  }

  .active {
    color: #fff !important;
    background: radial-gradient(50% 50% at 50% 50%, hsla(0, 0%, 9%, 0) 53.5%, #567eff 100%) !important;
    box-shadow: inset 0 0 32px hsla(244, 93%, 34%, 0.12) !important;
  }

  .circle {
    width: 3.2rem;
    height: 3.2rem;
    color: #8c96a5;
    font-size: .4rem;
    line-height: 1rem;
    text-align: center;
    // background: #161616;
    border-radius: 50%;
    position: absolute;
    z-index: 10;
    padding: 0.4rem;
    padding-top: 0.5rem;
    font-size: .48rem;
    text-align: center;
    color: #C7D1FA;
    box-shadow: inset 0 0 32px #474f74 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .circle1_un {
    top: 6.5rem;
    left: 0.9rem;

  }

  .circle1 {
    top: 6.5rem;
    left: 0.9rem;
  }

  .text1 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 6.5rem;
    left: 0.9rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .circle2 {
    top: 4.6rem;
    left: 4.2rem;


  }

  .text2 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 4.6rem;
    left: 4.2rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .circle3 {
    top: 4.6rem;
    right: 4.2rem;
  }

  .text3 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 4.6rem;
    left: 8.2rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .circle4 {
    top: 6.5rem;
    right: 0.9rem;
  }



  .text4 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 6.5rem;
    left: 11.2rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .gif {
    width: 100%;
    margin-top: 1rem;
  }

  .bottom {
    margin-top: 0.5rem;
    font-size: 0.56rem;
    color: #333;
    height: calc(70rem/50);
  }

}

.main-2 {
  margin-bottom: 1.6rem;
  padding-bottom: 0.6rem;
  // padding: 0 .3125rem;

  h3 {
    margin-top: 0;
    font-weight: 600;
    font-family: Arial, PingFangSC-Semibold, sans-serif;
    text-align: center;
    font-size: .72rem;
    color: #2c3e5c !important;
    margin-bottom: .8rem;
  }

  .sub_title {
    font-size: 0.48rem;
    padding-bottom: .4rem;

    color: #8D93AB;
  }

  .tab {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    padding: 0 1rem;
    font-size: 0.55rem;
    color: #191919;
    cursor: pointer;
    // 可滑动
    overflow-x: scroll;

    .tab-item {
      height: 1rem;
      margin-top: .2rem;

      &.active {
        font-size: 0.65rem;
        color: rgba(86, 126, 255, 1);
        text-decoration: rgba(86, 126, 255, 1);

        border-bottom: 0.1rem solid rgba(86, 126, 255, 1);
      }
    }


  }

  .swiper-container {
    margin-top: 0.5rem;
    width: 100%;
    height: 100%;
  }

  .slide1 {
    height: 1rem !important;
    background-color: transparent !important;

    display: flex;
    justify-content: space-between;
    align-items: center;


    .tab-item {
      height: 1rem;
      margin-top: .2rem;
      font-size: 0.55rem;

      &.active {
        margin-top: 0rem;
        font-size: 0.8rem;
        color: rgba(86, 126, 255, 1);
        text-decoration: rgba(86, 126, 255, 1);

        border-bottom: 0.3  rem solid rgba(86, 126, 255, 1);
      }
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;

      background-color: transparent !important;

      height: 1rem !important;


      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;

    background-color: #000;

    height: 10rem !important;


    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

}

.pagi_back_color {
  background-color: rgba(86, 126, 255, 1) !important;
}



.main-3 {
  height: 16.6rem;
  padding: 0 .5125rem;
  padding-top: 1.4rem;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/手机端/可视化/个性化定制背景.png');

  h3 {
    font-family: Arial, PingFangSC-Semibold, sans-serif;
    font-size: .72rem;
    color: #191919;
    opacity: 0.9;
    font-weight: normal !important;
  }

  .sub_title {
    margin-top: 0.5rem;
    font-size: 0.7rem;
    color: #191919;
    opacity: 0.9;
  }

  p {
    margin-top: 0.5rem;
    font-size: 0.54rem;
    color: #191919;
    opacity: 0.9 !important;
    line-height: 1rem;
  }

  .btn {
    margin-top: .6rem;
  }


}

.main-5 {
  // 一行两个div

  padding: 0 .3125rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-top: 0;
    font-weight: 600;
    font-family: Arial, PingFangSC-Semibold, sans-serif;
    text-align: center;
    font-size: .72rem;
    color: #2c3e5c !important;
    margin-bottom: .8rem;
  }

  .iso {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;

    .single-ce {
      margin-top: 0.5rem;
      width: 47%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: #fff;
      border-radius: 12px;
      transition: all 0.3s;
      border: 1px solid #fff;
      box-shadow: 0 0 16px rgb(6 27 39 / 14%);
      height: 100%;
      padding: 0.5rem 0;

      .icon {
        height: 40px;
        line-height: 40px;
        margin-bottom: 10px;
      }

      .text {
        font-size: .52rem;
        height: 1.5rem;
      }

      &:hover {
        border: 1px solid #1989ff;
        transform: translateY(-2px);
      }
    }
  }


}

.centre {
  padding: 0 .625rem;
}

.centre p {
  margin-top: .625rem;
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  color: #2c3e5c !important;

}

.centre button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  margin-top: .625rem;
  font-size: .52rem;
}

.main-2 {
  margin-top: 1.25rem;
  text-align: center;
  margin-bottom: .625rem;
}

.main-2 h3 {
  text-align: center;
  font-weight: normal;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
}

.main-2 img {
  margin-bottom: .625rem;
}

.main-2 p {
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  padding: 0 .875rem;
  color: #2c3e5c !important;
}


.main-6 {

  margin-top: 1rem;
  padding: 0.4125rem;

  .title {
    margin-top: 0;
    font-weight: 600;
    font-family: Arial, PingFangSC-Semibold, sans-serif;
    text-align: center;
    font-size: .72rem;
    color: #2c3e5c !important;
    margin-bottom: .8rem;
  }

  .partner-group {
    overflow: hidden;
    position: relative;
    margin-top: 1rem;

    .leftw {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 100%;
      background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .rightw {
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 100%;
      background: linear-gradient(to left, #fff, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .parner-bg {
      background: url(../../../assets/images/partner.png) 100% / contain repeat-x;
      width: 330vw;
      height: 220px;
      animation: Index-module_scrollToRight_HaAA0 30s infinite linear;
    }
  }
}

.contact {
  margin-top: 80px;
  padding: 0.4135rem;
  background: url(../../../assets/images/bg-contact.png) center/cover;

  .contact-box {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 13px 0 14px;
    position: relative;

    .left {
      h3 {
        position: absolute;
        color: #444;
        font-size: 0.7rem;
        top: 1rem;
        font-family: "PingFangSC-Semibold", sans-serif;
      }

      button {
        margin-top: 2rem;
      }
    }

    .right {
      width: 60%;

      .contact-img {
        position: relative;

        img {
          width: 100%;
        }

        .poab {
          position: absolute;
          width: 52px;
          height: 60px;
          left: 76%;
          top: 40%;
        }

        .yan {
          position: absolute;
          width: 24px;
          height: 63px;
          left: 91%;
          top: 40%;
        }

        .contact-light {
          position: absolute;
          width: 57px;
          height: 25px;
          left: 10%;
          top: 27%;
        }
      }
    }
  }
}

@keyframes slideshow {
  0% {
    left: 0;
  }

  100% {
    left: -200%;
  }
}

@-webkit-keyframes Index-module_scrollToRight_HaAA0 {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
  }
}

@keyframes Index-module_scrollToRight_HaAA0 {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
  }
}


.footer {
  position: relative;
  // margin-top: 1.6rem;
  padding: 0 .5313rem;
  background-color: #4d73ff;
}

.footer ul {
  margin: 0;
  padding: 0;
}

.footer ul li {
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer ul li p {
  font-size: .52rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.el-icon-arrow-right {
  font-size: .56rem;
  margin-right: -0.1rem;
  color: #fff;
}

.logn img {
  width: 5.625rem;
  height: 1.5625rem;
  margin-top: .625rem;
  margin-bottom: .625rem;
  /* width: ; */
  /* background-color: pink; */
}

.dianhua img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dianhua p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.dizhi {
  margin-top: .3125rem;
  margin-bottom: .625rem;
}

.dizhi img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dizhi p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.footer-bottom {
  border-top: 1px solid #eee;
  height: 1.4063rem;
}

.footer-bottom {
  padding-top: .3125rem;
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.aaa {
  display: block !important;
  position: fixed;
  top: 0;
  right: 0;
  width: 45%;
  height: 100%;
  background-color: #fff;
  z-index: 9999999999999;
}

.addbtn {
  width: 4.6rem;
  height: 1.44rem;
  background-color: #5d7bff !important;
  /* 不支持线性的时候显示 */
  background-image: linear-gradient(to right, #5d7bff, #7b9cff);
  border-radius: 0.1rem;
  margin-bottom: 1.25rem;
  margin-right: 0.8rem;
  font-size: .56rem;
  color: #fff !important;
  border: 0;
}

.listiscolor {
  padding: 0 .5625rem;
  padding-top: .3467rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .5333rem;
  height: 4.28rem;
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.mask {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.maskis {
  display: block;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.listiscolor {
  padding: 0 1.04rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .3125rem;
  background-color: #fff;
  height: 3.5rem;
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.erweima1 {
  display: none;
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-3.6rem, 3.6rem);
}

.erweima1 img {
  width: 7.2rem;
  height: 7.2rem;
}

.ismask {
  position: fixed;
  z-index: 1998 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;
}

.isnav {
  position: fixed;
  top: 2.4rem;
  right: 0;
  width: 9rem;
  height: 100%;
  background-color: #fff;

  ul {
    padding: 0 .48rem;

    li {
      height: 2.12rem;
      line-height: 2.12rem;
      color: #2c3e5c;
      font-size: .56rem;
      font-family: Arial, PingFangSC-Semibold, sans-serif;
      border-bottom: 1px solid #eee;
    }

    .subLi {
      padding-left: .58rem;
    }

    .menuLi {
      color: #5d7bff;
      font-family: Arial, PingFangSC-Semibold, sans-serif;

    }

    li:nth-child(1) {
      border-top: 1px solid #eee;
    }
  }
}

.iserweima {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;

  img {
    position: fixed;
    top: calc(50% - 90px);
    left: calc(50% - 90px);
    // width: 7.2rem;
    // height: 7.2rem;
    // left: 50% ;
    // top: 50% ;
    // transform: translate(-50%,-50%);
  }
}

.callUs {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .0);
  animation: callUsBG2 .5s forwards;
}

.callUs_2 {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .3);
  animation: callUsBG1 .5s forwards;
}

.callUs_dialog {
  position: fixed;
  width: 100%;
  height: 50%;
  bottom: -50%;
  // opacity: 0;
  background: #ffffff;
  border-radius: .2rem .2rem 0 0;
  animation: callUs .5s forwards;
}

.callUs_dialog_2 {
  position: fixed;
  width: 100%;
  height: 50%;
  bottom: 0%;
  // opacity: 0;
  background: #ffffff;
  border-radius: .2rem .2rem 0 0;
  animation: callUs1 .5s forwards;
}

.callUs_title {
  position: relative;
  height: 16%;
  // background: #4d73ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;

  .down {
    position: absolute;
    right: .8rem;
    height: .32rem;
  }

  p {
    font-size: .64rem;
    color: #000;
  }
}

.bottom_msg {
  height: 84%;
  padding: 0 .78rem;

  // background: #2c3e5c;
  p {
    margin-top: .6rem;
    font-size: .56rem;
    color: #000;
  }

  input {
    width: 13rem;
    margin-top: .6rem;
    margin-left: .25rem;
    height: 30px;
    font-size: .56rem;
    outline: none;
    border: 0;
    border-bottom: 1px solid #f3f3f3;
  }

  .callUs_btn {
    width: 13rem;
    height: 1.44rem;
    margin-top: 1.2rem;
    margin-left: .25rem;
    background-image: linear-gradient(to right, #5d7bff, #7b9cff);
    border-radius: 0.1rem;
    margin-bottom: 1.25rem;
    font-size: .56rem;
    color: #fff !important;
    border: 0;
  }
}

@keyframes callUs {
  0% {
    bottom: -50%;
  }

  100% {
    bottom: 0%;
  }
}

@keyframes callUs1 {
  0% {
    bottom: 0%;
  }

  100% {
    bottom: -50%;
  }
}

@keyframes callUsBG1 {
  0% {
    background: rgba(0, 0, 0, .3);
  }

  100% {
    background: rgba(0, 0, 0, .0);
  }
}

@keyframes callUsBG2 {
  0% {
    background: rgba(0, 0, 0, .0);
  }

  100% {
    background: rgba(0, 0, 0, .3);
  }
}
</style>
